export default "__VITE_PUBLIC_ASSET__03cc7033__"